module.exports = __webpack_public_path__ + "img/header.60b6fcfd.png";